const log = (...args: unknown[]) => {
  console.log(...args);
};

const error = (...args: unknown[]) => {
  console.error(...args);
};

export const logger = { log, error };
